import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ConfigurationService } from '@core/services/configuration.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class FooterComponent {
  hotline: string;
  readonly hotlineNumber: string;

  constructor(
      private translateService: TranslateService,
      private configurationService: ConfigurationService) {
    //translateService.get("footer.hotline").subscribe((res: string) => { this.hotline = res; });
    this.hotlineNumber = configurationService.hotlineNumber;
  }

}
